import { useCallback } from "react";
import { useCurrentAccountId } from "@zapier/identity";
import emitUserInteractionEvent, {
  UserInteractionName,
} from "./emitUserInteractionEvent";

// There currently is no confirm. The duplication starts immediately.
export type InterfaceDuplicateModalAction = "cancel";

export function useEmitInterfaceDuplicateModalEvent() {
  const accountId = useCurrentAccountId();

  const emit = useCallback(
    (optionSelected: InterfaceDuplicateModalAction) => {
      emitUserInteractionEvent({
        accountId,
        interactionName: UserInteractionName.InterfaceDuplicateModal,
        optionSelected,
      });
    },
    [accountId],
  );

  return { emit };
}
